import { render } from "./GroupSurveyAdminPanel.vue?vue&type=template&id=5ca50211&scoped=true"
import script from "./GroupSurveyAdminPanel.vue?vue&type=script&lang=js"
export * from "./GroupSurveyAdminPanel.vue?vue&type=script&lang=js"

import "./GroupSurveyAdminPanel.vue?vue&type=style&index=0&id=5ca50211&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca50211"]])

export default __exports__